<script lang="ts">
	import { Col, Row, Text } from '@Shelly/shelly-design-system';
	import LottiePlayer from 'src/components/LottiePlayer/LottiePlayer.svelte';
	import { format } from 'svelte-i18n';
</script>

<Text element="h2" class="mb-xs">
	{$format('presence_wizard_room_title', { default: 'Define your room' })}
</Text>
<p class="step-subtitle mb-l">
	{$format('presence_wizard_room_subtitle', {
		default:
			"Draw your room's shape and mark any areas you want the radar to ignore. This helps the sensor focus only on the space that matters.",
	})}
</p>

<Row>
	<Col sm="12" md="6" lg="6">
		<div class="concept-card">
			<div class="concept-lottie">
				<LottiePlayer
					src="/images/lottie/radar/BoundariesAddRemove.json"
					autoplay={true}
					loop={true}
					height={180}
					width={180}
					background="transparent"
				/>
			</div>
			<div class="concept-text">
				<p class="concept-title">
					{$format('presence_wizard_room_boundaries_title', { default: 'Room boundaries' })}
				</p>
				<p class="concept-body">
					{$format('presence_wizard_room_boundaries_body', {
						default:
							'Draw a rectangle that outlines your room. The radar will only track movement within this area.',
					})}
				</p>
			</div>
		</div>
	</Col>
	<Col sm="12" md="6" lg="6">
		<div class="concept-card">
			<div class="concept-lottie">
				<LottiePlayer
					src="/images/lottie/radar/BlindSpotsAddRemove.json"
					autoplay={true}
					loop={true}
					height={180}
					width={180}
					background="transparent"
				/>
			</div>
			<div class="concept-text">
				<p class="concept-title">
					{$format('presence_wizard_blind_spots_title', { default: 'Blind spots' })}
				</p>
				<p class="concept-body">
					{$format('presence_wizard_blind_spots_body', {
						default:
							'Mark areas the radar should ignore — like a busy hallway or a plant that triggers false detections.',
					})}
				</p>
			</div>
		</div>
	</Col>
</Row>

<div class="tip-bar">
	<i class="fas fa-lightbulb" aria-hidden="true"></i>
	{$format('presence_wizard_room_tip', {
		default:
			'You draw boundaries and blind spots directly on the radar grid in the zone editor — accessible from the main screen.',
	})}
</div>

<style>
	.step-subtitle {
		color: var(--color-text-secondary, rgba(255, 255, 255, 0.55));
		line-height: 1.5;
	}

	.concept-card {
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
		padding: 16px 12px;
		border-radius: 12px;
		background: var(--color-surface-2, rgba(255, 255, 255, 0.04));
		margin-bottom: 12px;
	}

	.concept-lottie {
		flex-shrink: 0;
	}

	.concept-title {
		margin: 4px 0 6px;
		font-weight: 600;
		font-size: 14px;
	}

	.concept-body {
		margin: 0;
		font-size: 13px;
		color: var(--color-text-secondary, rgba(255, 255, 255, 0.55));
		line-height: 1.45;
	}

	.tip-bar {
		display: flex;
		align-items: flex-start;
		gap: 8px;
		margin-top: 16px;
		padding: 10px 14px;
		border-radius: 8px;
		background: var(--color-info-alpha, rgba(0, 177, 255, 0.1));
		color: var(--color-info, #00b1ff);
		font-size: 13px;
		line-height: 1.4;
	}

	.tip-bar i {
		margin-top: 1px;
		flex-shrink: 0;
	}
</style>
